import React from 'react'

import { SideSummary } from '@components/common'

import GuideToRewarding from './assets/guide-to-rewarding.jpg'
import MembershipsStrategies from './assets/memberships-strategies.jpg'
import * as S from './styled'

export const HelpfulResources = () => {
  return (
    <SideSummary>
      <SideSummary.Item title="Helpful resources">
        <S.Container
          href="https://fourthwall.com/blog/5-memberships-strategies-from-fourthwall-creators"
          target="_blank"
        >
          <S.Name>5 Memberships Strategies from Fourthwall Creators ↗</S.Name>
          <S.Image src={MembershipsStrategies} />
        </S.Container>
      </SideSummary.Item>
      <SideSummary.Item>
        <S.Container
          href="https://help.fourthwall.com/hc/en-us/articles/13331279583387-Perks-A-Guide-to-Rewarding-Your-Members"
          target="_blank"
        >
          <S.Name>Perks: A Guide to Rewarding Your Members ↗</S.Name>
          <S.Image src={GuideToRewarding} />
        </S.Container>
      </SideSummary.Item>
    </SideSummary>
  )
}
